import $api from "@/api/index";
import { NotificationI } from "@/types/notifications";

export async function getNotifications(): Promise<NotificationI[]> {
  const res = await $api.get(`/notifications/`);

  return res.data;
}

export async function readNotifications({ ids }: { ids: number[] }) {
  const res = await $api.post(`/notifications/read/`, { ids });

  return res.data;
}

export async function readAllNotifications() {
  const res = await $api.post(`/notifications/read-all/`);

  return res.data;
}
